import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PreferenceForm from './PreferenceForm'; // Tercih formunu temsil eden bileşen
import { PreferencePeriod } from './_models'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert2'
import { useLang } from '../../../_metronic/i18n/Metronici18n';

const API_URL_REAL = process.env.REACT_APP_API_URL

const PreferencePage = (): React.ReactElement | null => {
    const [preferencePeriod, setPreferencePeriod] = useState<PreferencePeriod | null>(null);
    const [futurePeriods, setFuturePeriods] = useState<PreferencePeriod[]>([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const intl = useIntl();
    const lang = useLang()
    useEffect(() => {
        axios.get<PreferencePeriod[]>(`${API_URL_REAL}/Custom/GetPreferencePeriods`)
            .then(response => {
                const periods = response.data;
             
                const now = new Date();
                const activePeriod = periods.find(period =>
                    new Date(period.startDate) <= now && new Date(period.endDate) >= now
                );
                const future = periods.filter(period =>
                    new Date(period.startDate) > now
                );
                setPreferencePeriod(activePeriod || null);
                setFuturePeriods(future);
                setLoading(false);
            })
            .catch(error => {
                
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Error'
                    }),
                    text: intl.formatMessage({ id: error.response.data.message }),
                    icon: 'error',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/dashboard');
                    }
                })
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p> {intl.formatMessage({ id: 'Please_wait' })}</p>;
    }
    // if (!preferencePeriod) {
    //     return (
    //         <div>
    //             <div className="alert alert-danger">{intl.formatMessage({ id: 'Currently, there is no active preference period. Please check the guideline.' })}</div>
    //             {futurePeriods.length > 0 && (
    //                 <div>
    //                     <h2>{intl.formatMessage({
    //                         id: 'Upcoming Preference Periods'
    //                     })}:</h2>
    //                     <ul>
    //                         {futurePeriods.map((period, index) => (
    //                             <li key={index}>{period.name} ({new Date(period.startDate).toLocaleDateString()} - {new Date(period.endDate).toLocaleDateString()})</li>
    //                         ))}
    //                     </ul>
    //                 </div>
    //             )}
    //         </div>
    //     )
    // }

    return (
        <div>
            {lang === "tr" ? <h2>{preferencePeriod?.name}</h2>
                : <h2>{preferencePeriod?.nameEn}</h2>}

            {!preferencePeriod ?
                <div className='mt-5'>
                    <div className="alert alert-danger">{intl.formatMessage({ id: 'Currently, there is no active preference period. Please check the guideline.' })}</div>
                    {futurePeriods.length > 0 && (
                        <div>

                            <h2>{intl.formatMessage({ id: 'Upcoming Preference Periods' })}:</h2>
                            <ul>
                                {futurePeriods.map((period, index) => (
                                    <li key={index}>{period.name} ({new Date(period.startDate).toLocaleDateString()} - {new Date(period.endDate).toLocaleDateString()})</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div> : <></>}

            {/* Tercih formunu burada gösteriyoruz. Form için ilgili props'ları ekleyin. */}
            <PreferenceForm period={preferencePeriod} />
        </div>
    );
};

export default PreferencePage;
